const LOAN_AMOUNT_FACTOR = [
  'statement', 'routingNo', 'amountOfOpenLoans', 'numberOfOpenLoans', 'accountBalance', 'voe', 'lastPayday', 'payrollFrequency', 'state', 'program'
]

const PAYMENT_SCHEDULE_FACTOR = [
  'payrollFrequency', 'program', 'approvedAmount', 'lastPayday', 'firstDayOfWeek', 'paydayOnHoliday',
  'firstDayOfMonth', 'secondDayOfMonth', 'effectiveDate', 'paydayOnAvailable'
]

const LOAN_AGREEMENT_FACTOR = [
  'zip', 'address', 'state', 'accountNo', 'city', 'bankName', 'routingNo', 'firstName', 'middleName', 'lastName',
  'effectiveDate', 'paydayOnHoliday', 'payrollFrequency', 'firstDayOfWeek', 'approvedAmount', 'paydayOnAvailable', 'program'
]

export { LOAN_AMOUNT_FACTOR, PAYMENT_SCHEDULE_FACTOR, LOAN_AGREEMENT_FACTOR }
